var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-sumbit-modal"},[_c('div',{staticClass:"g-row g-row--justify_end"},[_c('div',{staticClass:"ds-caption ds-caption--hover ds-caption--pointer ds-caption--size_2md",on:{"click":_vm.closeForm}},[_vm._v("✖")])]),_c('form-submit',{on:{"subm":function($event){return _vm.closeModal()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }